var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-grafica"},[(_vm.data.agrupaciones)?_c('nav',{staticClass:"tipos"},_vm._l((_vm.data.agrupaciones),function(el,key){return _c('a',{key:key},[_vm._v(_vm._s(el))])}),0):_vm._e(),_c('div',{attrs:{"id":"chartdiv"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }